import type { ShareDialogPayload } from '@/types';
import { isLiveboardSharePayload } from '@/types';

export function getObjectIdFromPayload(payload: ShareDialogPayload): string | null {
  if (isLiveboardSharePayload(payload)) {
    return payload.liveboardId;
  }
  return payload.embedAnswerData.reportBookMetadata?.headerMetadata?.id ?? null;
}
